import wire from '../wire';

export default wire(
  'multi-site',
  ``,
  () => {
    // Migrated to dashboard_vue
    window.location.href = '/multi-site';
  },
  'MultiSiteController'
);



// WEBPACK FOOTER //
// ./app/pages/multi-site/_index.js